import React from 'react'
import {
  typographyScale,
  typographyWeights,
  typographyClassName,
} from '@enamelai/design-system'
import UiPreviewCanvas from '../components/UiPreviewCanvas'
import './TypographyShowcase.css'

const TypographyShowcase: React.FC = () => (
  <UiPreviewCanvas
    title="Typography"
    description="Size and weight are separate — compose a size class (ds-type-h1) with a weight class (ds-type-weight-regular / ds-type-weight-bold)."
    stageClassName="ui-preview__stage--wide typography-showcase__stage-wrap"
  >
    <div className="typography-showcase__sheet">
      {typographyScale.map((item) => (
        <section key={item.id} className="typography-showcase__row">
          <div>
            <p className="typography-showcase__label">{item.label}</p>
            <p className="typography-showcase__meta">
              {item.className} · {item.fontSize} / {item.lineHeight}
              {item.letterSpacing ? ` · ${item.letterSpacing}` : ''}
            </p>
          </div>
          <div className="typography-showcase__samples">
            {typographyWeights.map((weight) => (
              <div
                key={weight.id}
                className="typography-showcase__sample-block"
              >
                <p className="typography-showcase__sample-meta">
                  {weight.label} · {typographyClassName(item.id, weight.id)}
                </p>
                <p
                  className={`typography-showcase__sample ${typographyClassName(
                    item.id,
                    weight.id,
                  )}`}
                >
                  {item.sample}
                </p>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  </UiPreviewCanvas>
)

export default TypographyShowcase
